var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 30,
    viewBox: "0 0 187 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6015_97897)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6906 28.0945C24.8141 28.9839 24.2706 29.4039 23.4553 28.9839L16.7105 25.5992C15.8952 25.1792 14.561 25.1792 13.7457 25.5992L6.97623 28.9345C6.16092 29.3298 5.61738 28.9345 5.74092 28.0204L6.8774 20.5591C7.02564 19.6697 6.60563 18.385 5.98798 17.7426L0.774971 12.3567C0.13261 11.7143 0.354965 11.0472 1.24439 10.899L8.68095 9.68839C9.57038 9.54015 10.6574 8.77426 11.0775 7.95896L14.5857 1.28828C15.0057 0.47298 15.6975 0.497686 16.1175 1.28828L19.5764 7.98366C19.9964 8.79897 21.0588 9.56486 21.9482 9.7378L29.3847 11.0225C30.2742 11.1708 30.4965 11.8378 29.8542 12.4802L24.5423 17.8414C23.9 18.4838 23.48 19.7438 23.6282 20.6332L24.7153 28.0945H24.6906Z",
    fill: "url(#paint0_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M15.3516 1.06639C15.4999 1.06639 15.6481 1.21463 15.7716 1.46169L19.2305 8.15707C19.6999 9.0712 20.8611 9.91121 21.8741 10.1089L29.3106 11.3936C29.5824 11.443 29.78 11.5418 29.8295 11.6901C29.8789 11.8136 29.78 12.0359 29.5824 12.2336L24.2706 17.5948C23.5541 18.3113 23.0847 19.6949 23.2329 20.7078L24.32 28.1691C24.3447 28.4162 24.32 28.6138 24.2459 28.7126C24.2459 28.7126 24.1717 28.7867 24.0482 28.7867C23.9247 28.7867 23.7764 28.7373 23.6282 28.6632L16.8834 25.2785C16.4387 25.0561 15.8458 24.9326 15.2281 24.9326C14.6104 24.9326 14.0422 25.0561 13.5975 25.2785L6.82799 28.6138C6.67975 28.6879 6.53151 28.7373 6.40798 28.7373C6.25975 28.7373 6.21033 28.6879 6.21033 28.6632C6.13621 28.5644 6.0868 28.3667 6.13621 28.1197L7.2727 20.6584C7.42094 19.6455 7.00093 18.2619 6.28445 17.5454L1.02203 12.0854C0.824383 11.8877 0.725558 11.6654 0.774971 11.5418C0.824383 11.4183 1.02203 11.2948 1.2938 11.2453L8.73037 10.0347C9.74332 9.8618 10.9045 9.02179 11.3986 8.10766L14.9316 1.46169C15.0552 1.21463 15.2281 1.06639 15.3763 1.06639M15.3516 0.695801C15.0799 0.695801 14.8081 0.89345 14.5857 1.28875L11.0775 7.95942C10.6574 8.75002 9.57038 9.54062 8.68095 9.68886L1.24439 10.8995C0.354965 11.0477 0.132609 11.6901 0.774971 12.3571L6.03739 17.7678C6.67975 18.4101 7.07505 19.6949 6.92681 20.5843L5.79033 28.0456C5.6915 28.7126 5.96327 29.1079 6.43269 29.1079C6.60563 29.1079 6.80328 29.0585 7.00093 28.9597L13.7704 25.6244C14.1657 25.4267 14.7093 25.3279 15.2281 25.3279C15.7469 25.3279 16.3152 25.4267 16.7105 25.6491L23.4553 29.0338C23.6776 29.1326 23.8753 29.182 24.0482 29.182C24.5176 29.182 24.7894 28.7867 24.6906 28.1444L23.6035 20.6831C23.48 19.7937 23.9 18.509 24.5176 17.8913L29.8295 12.5301C30.4718 11.8877 30.2495 11.2206 29.36 11.0724L21.9235 9.78768C21.0341 9.63944 19.947 8.84885 19.5517 8.03354L16.1175 1.31346C15.9199 0.89345 15.6234 0.695801 15.3516 0.695801Z",
    fill: "url(#paint1_radial_6015_97897)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.654 28.0953C63.7776 28.9847 63.234 29.4047 62.4187 28.9847L55.6739 25.6C54.8586 25.18 53.5245 25.18 52.7092 25.6L45.9397 28.9353C45.1244 29.3306 44.5809 28.9353 44.7044 28.0212L45.8409 20.5599C45.9891 19.6705 45.5691 18.3858 44.9515 17.7434L39.689 12.3327C39.0467 11.6904 39.269 11.0233 40.1585 10.8751L47.595 9.66446C48.4844 9.51623 49.5715 8.75034 49.9915 7.93503L53.4998 1.26436C53.9198 0.449054 54.6116 0.47376 55.0316 1.26436L58.4904 7.95974C58.9105 8.77504 59.9728 9.54093 60.8622 9.71388L68.2988 10.9986C69.1882 11.1468 69.4106 11.8139 68.7682 12.4563L63.4564 17.8175C62.814 18.4599 62.394 19.7199 62.5423 20.6093L63.6293 28.0706L63.654 28.0953Z",
    fill: "url(#paint2_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M54.3126 1.06639C54.4608 1.06639 54.609 1.21463 54.7573 1.46169L58.2161 8.15707C58.6856 9.0712 59.8468 9.91121 60.8597 10.1089L68.2963 11.3936C68.568 11.443 68.7657 11.5418 68.8151 11.6901C68.8645 11.8136 68.7657 12.0359 68.568 12.2336L63.2562 17.5948C62.5397 18.3113 62.0703 19.6949 62.2185 20.7078L63.3056 28.1691C63.3303 28.4162 63.3056 28.6138 63.2315 28.7126C63.2315 28.7126 63.1574 28.7867 63.0339 28.7867C62.9103 28.7867 62.7621 28.7373 62.6138 28.6632L55.8691 25.2785C55.4243 25.0561 54.8314 24.9326 54.2137 24.9326C53.5961 24.9326 53.0278 25.0561 52.5831 25.2785L45.8136 28.6138C45.6654 28.6879 45.5172 28.7373 45.3936 28.7373C45.2454 28.7373 45.196 28.6879 45.1713 28.6632C45.0972 28.5644 45.0477 28.3667 45.0972 28.1197L46.2336 20.6584C46.3819 19.6455 45.9372 18.2619 45.2207 17.5454L39.9583 12.1348C39.7606 11.9371 39.6618 11.7148 39.7112 11.5912C39.7606 11.4677 39.9583 11.3442 40.23 11.2948L47.6666 10.0842C48.6795 9.91121 49.8407 9.0712 50.3349 8.15707L53.8431 1.4864C53.9667 1.23934 54.1396 1.0911 54.2879 1.0911M54.3126 0.695801C54.0408 0.695801 53.769 0.89345 53.5467 1.28875L50.0384 7.95942C49.6184 8.75002 48.5313 9.54062 47.6419 9.68886L40.2053 10.8995C39.3159 11.0477 39.0935 11.6901 39.7359 12.3571L44.9983 17.7678C45.6407 18.4101 46.036 19.6949 45.8878 20.5843L44.7513 28.0456C44.6524 28.7126 44.9242 29.1079 45.3936 29.1079C45.5666 29.1079 45.7642 29.0585 45.9619 28.9597L52.7314 25.6244C53.1267 25.4267 53.6702 25.3279 54.189 25.3279C54.7079 25.3279 55.2761 25.4267 55.6714 25.6491L62.4162 29.0338C62.6386 29.1326 62.8362 29.182 63.0091 29.182C63.4786 29.182 63.7503 28.7867 63.6515 28.1444L62.5644 20.6831C62.4409 19.7937 62.8609 18.509 63.4786 17.8913L68.7904 12.5301C69.4328 11.8877 69.2104 11.2206 68.321 11.0724L60.8844 9.78768C59.995 9.63944 58.9326 8.84885 58.5126 8.03354L55.0538 1.33816C54.8314 0.942863 54.5596 0.720507 54.2879 0.720507L54.3126 0.695801Z",
    fill: "url(#paint3_radial_6015_97897)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.59 28.0953C102.714 28.9847 102.17 29.4047 101.355 28.9847L94.6102 25.6C93.7949 25.18 92.4607 25.18 91.6701 25.6L84.9006 28.9353C84.0853 29.3306 83.5418 28.9353 83.6653 28.0212L84.8018 20.5599C84.95 19.6705 84.53 18.3858 83.9124 17.7434L78.65 12.3327C78.0076 11.6904 78.23 11.0233 79.1194 10.8751L86.556 9.66446C87.4454 9.51623 88.5324 8.75034 88.9525 7.93503L92.4607 1.26436C92.8807 0.449054 93.5725 0.47376 93.9925 1.26436L97.4514 7.95974C97.8714 8.77504 98.9338 9.54093 99.8232 9.71388L107.26 10.9986C108.149 11.1468 108.372 11.8139 107.729 12.4563L102.417 17.8175C101.775 18.4599 101.355 19.7199 101.503 20.6093L102.59 28.0706V28.0953Z",
    fill: "url(#paint4_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M93.254 1.06639C93.4022 1.06639 93.5504 1.21463 93.6987 1.46169L97.1575 8.15707C97.627 9.0712 98.7882 9.91121 99.8011 10.1089L107.238 11.3936C107.509 11.443 107.707 11.5418 107.757 11.6901C107.806 11.8136 107.707 12.0359 107.509 12.2336L102.198 17.5948C101.481 18.3113 101.012 19.6949 101.16 20.7078L102.247 28.1691C102.272 28.4162 102.247 28.6138 102.173 28.7126C102.173 28.7126 102.099 28.7867 101.975 28.7867C101.852 28.7867 101.703 28.7373 101.555 28.6632L94.8105 25.2785C94.3657 25.0561 93.7728 24.9326 93.1551 24.9326C92.5375 24.9326 91.9692 25.0561 91.5245 25.2785L84.755 28.6138C84.6068 28.6879 84.4586 28.7373 84.335 28.7373C84.1868 28.7373 84.1374 28.6879 84.1127 28.6632C84.0386 28.5644 83.9891 28.3667 84.0386 28.1197L85.175 20.6584C85.3233 19.6455 84.8786 18.2619 84.1621 17.5454L78.8997 12.1348C78.702 11.9371 78.6032 11.7148 78.6526 11.5912C78.702 11.4677 78.8997 11.3442 79.1714 11.2948L86.608 10.0842C87.621 9.91121 88.7821 9.0712 89.2763 8.15707L92.7845 1.4864C92.9081 1.23934 93.081 1.0911 93.2293 1.0911M93.254 0.695801C92.9822 0.695801 92.7104 0.89345 92.4881 1.28875L88.9798 7.95942C88.5598 8.75002 87.4727 9.54062 86.5833 9.68886L79.1467 10.8995C78.2573 11.0477 78.035 11.6901 78.6773 12.3571L83.9397 17.7678C84.5821 18.4101 84.9774 19.6949 84.8292 20.5843L83.6927 28.0456C83.5938 28.7126 83.8656 29.1079 84.335 29.1079C84.508 29.1079 84.7056 29.0585 84.9033 28.9597L91.6728 25.6244C92.0681 25.4267 92.6116 25.3279 93.1304 25.3279C93.6493 25.3279 94.2175 25.4267 94.6128 25.6491L101.358 29.0338C101.58 29.1326 101.778 29.182 101.951 29.182C102.42 29.182 102.692 28.7867 102.593 28.1444L101.506 20.6831C101.382 19.7937 101.802 18.509 102.42 17.8913L107.732 12.5301C108.374 11.8877 108.152 11.2206 107.262 11.0724L99.8258 9.78768C98.9364 9.63944 97.874 8.84885 97.454 8.03354L93.9952 1.33816C93.7975 0.942863 93.501 0.720507 93.2293 0.720507L93.254 0.695801Z",
    fill: "url(#paint5_radial_6015_97897)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.556 28.0953C141.68 28.9847 141.136 29.4047 140.321 28.9847L133.576 25.6C132.761 25.18 131.427 25.18 130.612 25.6L123.842 28.9353C123.027 29.3306 122.483 28.9353 122.607 28.0212L123.743 20.5599C123.891 19.6705 123.471 18.3858 122.854 17.7434L117.591 12.3327C116.949 11.6904 117.171 11.0233 118.061 10.8751L125.497 9.66446C126.387 9.51623 127.474 8.75034 127.894 7.93503L131.402 1.26436C131.822 0.449054 132.514 0.47376 132.934 1.26436L136.393 7.95974C136.813 8.77504 137.875 9.54093 138.765 9.71388L146.201 10.9986C147.091 11.1468 147.313 11.8139 146.671 12.4563L141.359 17.8175C140.716 18.4599 140.296 19.7199 140.445 20.6093L141.532 28.0706L141.556 28.0953Z",
    fill: "url(#paint6_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M132.215 1.06639C132.363 1.06639 132.511 1.21463 132.66 1.46169L136.118 8.15707C136.588 9.0712 137.749 9.91121 138.762 10.1089L146.199 11.3936C146.47 11.443 146.668 11.5418 146.717 11.6901C146.767 11.8136 146.668 12.0359 146.47 12.2336L141.159 17.5948C140.442 18.3113 139.973 19.6949 140.121 20.7078L141.208 28.1691C141.233 28.4162 141.208 28.6138 141.134 28.7126C141.134 28.7126 141.06 28.7867 140.936 28.7867C140.813 28.7867 140.664 28.7373 140.516 28.6632L133.771 25.2785C133.327 25.0561 132.734 24.9326 132.116 24.9326C131.498 24.9326 130.93 25.0561 130.485 25.2785L123.716 28.6138C123.568 28.6879 123.42 28.7373 123.296 28.7373C123.148 28.7373 123.098 28.6879 123.074 28.6632C122.999 28.5644 122.95 28.3667 122.999 28.1197L124.136 20.6584C124.284 19.6455 123.864 18.2619 123.148 17.5454L117.885 12.1348C117.688 11.9371 117.589 11.7148 117.638 11.5912C117.688 11.4677 117.885 11.3442 118.157 11.2948L125.594 10.0842C126.607 9.91121 127.768 9.0712 128.262 8.15707L131.77 1.4864C131.894 1.23934 132.067 1.0911 132.215 1.0911M132.215 0.695801C131.943 0.695801 131.671 0.89345 131.449 1.28875L127.941 7.95942C127.521 8.75002 126.434 9.54062 125.544 9.68886L118.108 10.8995C117.218 11.0477 116.996 11.6901 117.638 12.3571L122.901 17.7678C123.543 18.4101 123.938 19.6949 123.79 20.5843L122.654 28.0456C122.555 28.7126 122.827 29.1079 123.296 29.1079C123.469 29.1079 123.667 29.0585 123.864 28.9597L130.634 25.6244C131.029 25.4267 131.573 25.3279 132.091 25.3279C132.61 25.3279 133.178 25.4267 133.574 25.6491L140.319 29.0338C140.541 29.1326 140.739 29.182 140.911 29.182C141.381 29.182 141.653 28.7867 141.554 28.1444L140.467 20.6831C140.343 19.7937 140.763 18.509 141.381 17.8913L146.693 12.5301C147.335 11.8877 147.113 11.2206 146.223 11.0724L138.787 9.78768C137.897 9.63944 136.81 8.84885 136.415 8.03354L132.956 1.33816C132.758 0.942863 132.462 0.720507 132.19 0.720507L132.215 0.695801Z",
    fill: "url(#paint7_radial_6015_97897)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.489 28.0953C180.612 28.9847 180.069 29.4047 179.253 28.9847L172.509 25.6C171.693 25.18 170.359 25.18 169.569 25.6L162.799 28.9353C161.984 29.3306 161.44 28.9353 161.564 28.0212L162.7 20.5599C162.848 19.6705 162.428 18.3858 161.811 17.7434L156.548 12.3327C155.906 11.6904 156.128 11.0233 157.018 10.8751L164.454 9.66446C165.344 9.51623 166.431 8.75034 166.851 7.93503L170.359 1.26436C170.779 0.449054 171.471 0.47376 171.891 1.26436L175.35 7.95974C175.77 8.77504 176.832 9.54093 177.722 9.71388L185.158 10.9986C186.048 11.1468 186.27 11.8139 185.628 12.4563L180.316 17.8175C179.673 18.4599 179.253 19.7199 179.402 20.6093L180.489 28.0706V28.0953Z",
    fill: "url(#paint8_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M171.152 1.06639C171.301 1.06639 171.449 1.21463 171.597 1.46169L175.056 8.15707C175.525 9.0712 176.687 9.91121 177.7 10.1089L185.136 11.3936C185.408 11.443 185.606 11.5418 185.655 11.6901C185.704 11.8136 185.606 12.0359 185.408 12.2336L180.096 17.5948C179.38 18.3113 178.91 19.6949 179.058 20.7078L180.145 28.1691C180.17 28.4162 180.145 28.6138 180.071 28.7126C180.071 28.7126 179.997 28.7867 179.874 28.7867C179.75 28.7867 179.602 28.7373 179.454 28.6632L172.709 25.2785C172.264 25.0561 171.671 24.9326 171.054 24.9326C170.436 24.9326 169.868 25.0561 169.423 25.2785L162.653 28.6138C162.505 28.6879 162.357 28.7373 162.233 28.7373C162.085 28.7373 162.036 28.6879 162.036 28.6632C161.937 28.5644 161.912 28.3667 161.962 28.1197L163.098 20.6584C163.246 19.6455 162.826 18.2619 162.11 17.5454L156.848 12.1348C156.65 11.9371 156.551 11.7148 156.6 11.5912C156.65 11.4677 156.848 11.3442 157.119 11.2948L164.556 10.0842C165.569 9.91121 166.73 9.0712 167.224 8.15707L170.732 1.4864C170.856 1.23934 171.029 1.0911 171.177 1.0911M171.152 0.695801C170.881 0.695801 170.609 0.89345 170.387 1.28875L166.878 7.95942C166.458 8.75002 165.371 9.54062 164.482 9.68886L157.045 10.8995C156.156 11.0477 155.933 11.6901 156.576 12.3571L161.838 17.7678C162.481 18.4101 162.876 19.6949 162.728 20.5843L161.591 28.0456C161.492 28.7126 161.764 29.1079 162.233 29.1079C162.406 29.1079 162.604 29.0585 162.802 28.9597L169.571 25.6244C169.967 25.4267 170.51 25.3279 171.029 25.3279C171.548 25.3279 172.116 25.4267 172.511 25.6491L179.256 29.0338C179.478 29.1326 179.676 29.182 179.849 29.182C180.318 29.182 180.59 28.7867 180.491 28.1444L179.404 20.6831C179.281 19.7937 179.701 18.509 180.318 17.8913L185.63 12.5301C186.273 11.8877 186.05 11.2206 185.161 11.0724L177.724 9.78768C176.835 9.63944 175.748 8.84885 175.352 8.03354L171.894 1.33816C171.696 0.942863 171.399 0.720507 171.128 0.720507L171.152 0.695801Z",
    fill: "url(#paint9_radial_6015_97897)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.658 12.4803C186.3 11.8379 186.078 11.1708 185.188 11.0226L177.752 9.73788C176.862 9.58964 175.775 8.79905 175.38 7.98374L171.921 1.28836C171.723 0.893062 171.451 0.769531 171.18 0.769531V25.3028C171.674 25.3028 172.143 25.4016 172.514 25.5993L179.259 28.984C180.074 29.3793 180.617 28.984 180.494 28.0946L179.407 20.6333C179.283 19.7439 179.703 18.4592 180.321 17.8415L185.633 12.4803H185.658Z",
    fill: "url(#paint10_radial_6015_97897)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M185.658 12.4807C186.3 11.8383 186.078 11.1712 185.188 11.023L177.752 9.73827C176.862 9.59003 175.775 8.79943 175.38 7.98413L171.921 1.28875C171.723 0.89345 171.451 0.695801 171.18 0.695801V1.06639C171.303 1.06639 171.451 1.21463 171.575 1.46169L175.034 8.15707C175.503 9.0712 176.664 9.91121 177.677 10.1089L185.114 11.3936C185.386 11.443 185.583 11.5418 185.633 11.6901C185.682 11.8136 185.583 12.0359 185.386 12.2336L180.074 17.5948C179.357 18.3113 178.888 19.6949 179.036 20.7078L180.123 28.1691C180.148 28.4162 180.123 28.6138 180.049 28.7126C180.049 28.7126 179.975 28.7867 179.852 28.7867C179.728 28.7867 179.58 28.7373 179.432 28.6632L172.687 25.2785C172.267 25.0808 171.748 24.9573 171.18 24.9573V25.3279C171.674 25.3279 172.143 25.4267 172.514 25.6244L179.259 29.0091C179.481 29.1079 179.679 29.1573 179.852 29.1573C180.321 29.1573 180.593 28.762 180.494 28.1197L179.407 20.6584C179.283 19.769 179.703 18.4843 180.321 17.8666L185.633 12.5054L185.658 12.4807Z",
    fill: "url(#paint11_radial_6015_97897)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.46915 29.5028) scale(31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.09735 37.2363) scale(45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4079 1.93143) scale(31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0336 37.2363) scale(45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.3689 1.93143) scale(31.1792 31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.9997 37.2363) scale(45.0888 45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.31 1.93143) scale(31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.936 37.2363) scale(45.0888 45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.267 1.93143) scale(31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.898 37.2363) scale(45.0888 45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFBC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAE18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF9736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF953A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.273 29.5028) scale(31.1792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6015_97897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.901 37.2363) scale(45.0888 45.0888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6015_97897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.618,
    height: 28.4615,
    fill: "white",
    transform: "translate(0.40625 0.695801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d31bab03ab3891898ea549a2b9fabfcb.svg";
export { ForwardRef as ReactComponent };